import { DismissiblePagePanels } from './shared-page-types.js';

export type SetPanelPayload = {
  /** A unique identifier for this panel. */
  name: DismissiblePagePanels;
  /** The current dismissed state of the panel. */
  defaultDismissed?: boolean;
  /** Whether the panel is rendered as drawer. */
  drawer?: boolean;
  /** Whether the panel is controlled. */
  controlled?: boolean;
  /** The breakpoint where the panel switches from a drawer to a panel. */
  breakpoint?: number;
  /** User action that has been performed for the panel, if any. */
  userAction?: 'open' | 'close';
};

export const enum PagePanelsActions {
  SETPANEL = 'set',
}

export type PagePanelsReducerActions = {
  type: PagePanelsActions.SETPANEL;
  payload: SetPanelPayload;
};

export type PagePanelsState = {
  [key in DismissiblePagePanels]: {
    controlled: boolean;
    defaultDismissed?: boolean;
    drawer?: boolean;
    userAction?: 'open' | 'close';
    breakpoint: number;
  };
};
